export default "__VITE_ASSET__DFwLNBE___"